import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import axios from 'axios';
import { BASE_URL } from './../../Environment';
import { toast } from 'react-toastify';
import Info from './Info';
import { format } from 'date-fns';

function Payout() {
    const accessToken = localStorage.getItem('accessToken');
    const [isLoading, setIsLoading] = useState(false);
    const [total, setTotal] = useState('');
    const [payout, setPayout] = useState([]);
    useEffect(() => {
        document.title = 'Infomart | Agent Payout';
        setIsLoading(true);
        axios.get(`${BASE_URL}/agent/payout`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setTotal(res.data.total);
            setPayout(res.data.data);
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
    }, []);
    return (
        <div className="app">
            <div className="outlet">
                <Info />
                <div className="homeLayout">
                    <Sidebar />
                    {isLoading ?
                        <h5 className="text-center mt-5">Loading...</h5>
                        :
                        <div className="card">
                            <div className="card-header fw-bold">Payout
                                <span className="float-end">Total: ₹{total}.00</span>
                            </div>
                            {/* <div className="card-body">    */}
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Business</th>
                                            <th scope="col">Amount</th>
                                            <th scope="col">Commission</th>
                                            <th scope="col">Acc. Maintain</th>
                                            <th scope="col">TDS</th>
                                            <th scope="col">Net Payout</th>
                                            <th scope="col">Payment Date</th>
                                            <th scope="col">Ref. No.</th>
                                            <th scope="col">Note</th>
                                            <th scope="col">Date</th>
                                        </tr>
                                    </thead>
                                    <tbody className="align-middle">
                                        {payout && payout.length > 0 ? (
                                            payout.map((data, i) => (
                                                <tr key={i}>
                                                    <th scope="row">{i + 1}</th>
                                                    <td>₹{data.business}.00</td>
                                                    <td>₹{data.amount}.00</td>
                                                    <td>₹{data.total_commission}.00</td>
                                                    <td>₹{data.acc_maintain_charge}.00</td>
                                                    <td>₹{data.tds}.00</td>
                                                    <td>₹{data.net_payout}.00</td>
                                                    <td>
                                                        {data.payment_date ? format(new Date(data.payment_date), 'dd MMM, yyyy') : 'N/A'}
                                                    </td>

                                                    <td>{data.ref_no}</td>
                                                    <td>{data.note}</td>
                                                    <td>{format(data.created_at, 'dd MMM, yyyy')}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <th colSpan="8" className="text-center">No data available.</th>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default Payout;               